<template>
  <v-app>
    <div class="pa-2 pa-md-4 align-center justify-center d-flex flex-column">
      <Nuxt />
    </div>

    <v-snackbar
      v-if="toast.show"
      :value="true"
      :timeout="toast.timeout"
      :color="toast.color"
      :min-width="50"
      bottom
    >
      {{ toast.message }}
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('app', ['toast']),
  },
}
</script>
